sunday:
    en: Sunday
    es: Domingo
    fr: Dimanche
    pt: domingo
    ru: Воскресенье
sunday_short:
    en: Su
    es: Do
    fr: Dim
    pt: Dom
    ru: Вс
monday:
    en: Monday
    es: Lunes
    fr: Lundi
    pt: segunda
    ru: Понедельник
monday_short:
    en: Mo
    es: Lu
    fr: Lun
    pt: Seg
    ru: Пн
tuesday:
    en: Tuesday
    es: Martes
    fr: Mardi
    pt: terça
    ru: Вторник
tuesday_short:
    en: Tu
    es: Ma
    fr: Mar
    pt: Ter
    ru: Вт
wednesday:
    en: Wednesday
    es: Miercoles
    fr: Mercredi
    pt: quarta
    ru: Среда
wednesday_short:
    en: We
    es: Mi
    fr: Mer
    pt: Qua
    ru: Ср
thursday:
    en: Thursday
    es: Jueves
    fr: Jeudi
    pt: quinta
    ru: Четверг
thursday_short:
    en: Th
    es: Ju
    fr: Jeu
    pt: Qui
    ru: Чт
friday:
    en: Friday
    es: Viernes
    fr: Vendredi
    pt: sexta
    ru: Пятница
friday_short:
    en: Fr
    es: Vi
    fr: Ven
    pt: Sex
    ru: Пт
saturday:
    en: Saturday
    es: Sábado
    fr: Samedi
    pt: sábado
    ru: Суббота
saturday_short:
    en: Sa
    es: Sá
    fr: Sam
    pt: Sáb
    ru: Сб
holiday:
    en: Holidays
    es: Descanso
    fr: Vacances
    pt: feriado
    ru: Праздники
holiday_short:
    en: H
    es: Des
    fr: Vac
    pt: fer
    ru: Пр
today:
    en: Today
    ru: Сегодня
    es: Hoy
    pt: Hoje
    fr: "Aujourd'hui"
minutesShort:
    en: min
    ru: мин
    es: min
    pt: min
    fr: min
hoursShort:
    en: h
    ru: ч
    es: h
    pt: h
    fr: h
daysShort:
    en: d
    ru: д
    es: d
    pt: d
    fr: d
